export const calculateCurrentCuatrimestreYYYYMMDD = () => {
    // Fixed: Use getCurrentCycle() logic to get correct cycle (1, 2, or 3)
    const possibilities = ["02", "03", "01"]
        .map(o => o === "01"
            ? `${new Date().getFullYear() + 1}-${o}`
            : `${new Date().getFullYear()}-${o}`
        );
    const index = Math.floor(new Date().getMonth() / 4);
    return `${possibilities[index]}-01`;
}

export const calculateCurrentCuatrimestreYYYYCC = () => {
    // Fixed: Use getCurrentCycle() logic to get correct cycle (1, 2, or 3)
    const possibilities = ["02", "03", "01"]
        .map(o => o === "01"
            ? `${new Date().getFullYear() + 1}-${o}`
            : `${new Date().getFullYear()}-${o}`
        );
    const index = Math.floor(new Date().getMonth() / 4);
    return possibilities[index];
}

export const calculateCurrentCycleYYCC = () => {
    // Fixed: Use getCurrentCycle() logic and format to YY-0C
    const possibilities = ["02", "03", "01"]
        .map(o => o === "01"
            ? `${new Date().getFullYear() + 1 - 2000}-${o}`
            : `${new Date().getFullYear() - 2000}-${o}`
        );
    const index = Math.floor(new Date().getMonth() / 4);
    return possibilities[index];
}

export const K_ALERT = {
    SEVERITY: {
        SUCCESS: 'success',
        ERROR: 'error'
    },
    MESSAGE: {
        ERROR: 'Por favor intente de nuevo',
        GROUPS: {
            GROUP_DELETE: "El grupo ha sido dado de baja del sistema exitosamente",
            GROUP_UPDATE: "Los datos del grupo han sido actualizado exitosamente",
            GROUP_CREATE: "El grupo ha sido dado de creado exitosamente",
            GROUP_ADD_USER_TO_GROUP: "El estudiante ha sido añadido al grupo exitosamente",
            GROUP_DELETE_USER_FROM_GROUP: "El estudiante ha sido removido al grupo exitosamente",
        },
        STUDENTS: {
            STUDENT_DELETE: "El estudiante ha sido dado de baja del sistema exitosamente",
            STUDENT_UPDATE: "Los datos del estudiante han sido actualizado exitosamente",
            STUDENT_CREATE: "El estudiante ha sido dado de alta exitosamente"
        },
        PROFESSORS: {
            PROFESSOR_DELETE: "El profesor ha sido dado de baja del sistema exitosamente",
            PROFESSOR_UPDATE: "Los datos del profesor han sido actualizado exitosamente",
            PROFESSOR_CREATE: "El profesor ha sido dado de alta exitosamente"
        },
        TOPICS: {
            TOPICS_UPDATE_PROFESSOR: "El profesor ha sido vinculado exitosamente",
            TOPICS_UPDATE_SCHEDULE: "El horario ha sido actualizado exitosamente",
        },
        GRADES: {
            GRADES_UPDATED: "Las calificaciones han sido guardades exitosamente",
        },
        COGNITO_USERS: {
            COGNITO_USER_UPDATE: "Los datos del usuario han sido actualizado exitosamente",
            COGNITO_USER_CREATE: "El usuario ha sido dado de alta exitosamente",
            COGNITO_USER_DELETE: "El usuario ha sido dado de baja del sistema exitosamente",
        },
        CONFIGURATION: {
            AVERAGES_REQUEST_ACCEPTED: "La solicitud ha sido recibida. Recibirás un correo con el CSV cuando el proceso esté completo",
        }
    }
};

export const openAlert = (alertFunction, message = K_ALERT.MESSAGE.ERROR, severity = K_ALERT.SEVERITY.ERROR) => {
    alertFunction({
        open: true,
        message: message,
        severity: severity
    });
};

export const getListOfCyclesWithObjects = (lookupObject = false) => {
    const currentYear = new Date().getFullYear();
    const currentYearCycle = Math.ceil(parseFloat((new Date().getMonth()) / 4));
    let cyclesObject = [];
    for (let i = -2; i <= 2; i++) {
        const cycle = (currentYearCycle + i) % 3
        const yearGap = currentYearCycle + i <= 0 ? -1 : (currentYearCycle + i) === 3 ? 0 : parseInt((currentYearCycle + i) / 3);
        let cycleForObject = `${currentYear + yearGap}-0${cycle === 0 ? 3 : cycle}`
        cyclesObject[cycleForObject] = (cycleForObject === `${currentYear}-0${currentYearCycle}`);
    }
    return lookupObject ? Object.keys(cyclesObject).map(cycle => {return {[cycle]: cycle}}) : cyclesObject;
}

/**
 *
 * @returns "2020-02" YYYY-0X, where X is the cycle
 */
export const getCurrentCycle = () => {
    return `${new Date().getFullYear()}-0${Math.ceil(parseFloat(new Date().getMonth() / 4))}`;
};


export const majors = () => {
    return {
        "AMBIENTAL": "Ambiental",
        "INDUSTRIAL": "Industrial",
        "PETROLERA": "Petrolero",
        "ADMINISTRACION": "Administración",
        "DERECHO": "Derecho",
        "PSICOPEDAGOGIA": "Psicopedagogía",
        "MAESTRIAEDUCACION": "Maestría Educación",
        "MAESTRIAPETROLERA": "Maestría Petrolera",
        "ENFERMERIA": "Enfermería",
        "ENFERMERIA_SEMESTRAL": "Enfermería Semestral",
        "LOGISTICA": "Logística",
    };
};

export const PAYMENTS_CONCEPTS = {
    "EGRESO": "EGRESO",
    "EGRESO_GASTO": "EGRESO GASTO",
    "EGRESO_CORTE": "EGRESO CORTE",
    "CEDAR_UNIFORMES": "CEDAR_UNIFORMES",
    "CEDAR_TINES": "CEDAR_TINES",
    "CEDAR_LIBRETA": "CEDAR_LIBRETA",
    "CEDAR_INTERSEMESTRAL": "CEDAR_INTERSEMESTRAL",
    "CEDAR_INTRASEMESTRAL": "CEDAR_INTRASEMESTRAL",
    "CEDAR_REINSCRIPCION": "CEDAR_REINSCRIPCION",
    "CEDAR_BAJA_DEFINITIVA": "CEDAR_BAJA_DEFINITIVA",
    "CEDAR_CONSTANCIA_PARCIAL": "CEDAR_CONSTANCIA_PARCIAL",
    "CEDAR_CONSTANCIA_SIMPLE": "CEDAR_CONSTANCIA_SIMPLE",
    "CEDAR_CONSTANCIA_PASAPORTE": "CEDAR_CONSTANCIA_PASAPORTE",
    "CEDAR_CONSTANCIA_CALIFICACIONES": "CEDAR_CONSTANCIA_CALIFICACIONES",
    "CEDAR_SECU_LIBROS": "CEDAR_SECU_LIBROS",
    "CEDAR_PREPA_LIBROS": "CEDAR_PREPA_LIBROS",
    "CEDAR_SECU_INSCRIPCION": "CEDAR_SECU_INSCRIPCION",
    "CEDAR_PREPA_INSCRIPCION": "CEDAR_PREPA_INSCRIPCION",
    "CEDAR_SECU_REINSCRIPCION": "CEDAR_SECU_REINSCRIPCION",
    "CEDAR_PREPA_REINSCRIPCION": "CEDAR_PREPA_REINSCRIPCION",
    "CEDAR_SECU_CUOTA_ANUAL": "CEDAR_SECU_CUOTA_ANUAL",
    "CEDAR_PREPA_CUOTRA_ANUAL": "CEDAR_PREPA_CUOTRA_ANUAL",
    "CEDAR_SECU_COLEGIATURA_10": "CEDAR_SECU_COLEGIATURA_10",
    "CEDAR_PREPA_COLEGIATURA_10": "CEDAR_PREPA_COLEGIATURA_10",
    "CEDAR_SECU_COLEGIATURA_12": "CEDAR_SECU_COLEGIATURA_12",
    "CEDAR_PREPA_COLEGIATURA_12": "CEDAR_PREPA_COLEGIATURA_12",
    "CEDAR_LIBROS": "CEDAR LIBROS",
    "CEDAR_INSCRIPCION": "CEDAR INSCRIPCION",
    "CEDAR_CUOTA_ANUAL": "CEDAR CUOTA ANUAL",
    "UVT_COLEGIATURA": "UVT COLEGIATURA",
    "UVT_INSCRIPCION": "UVT INSCRIPCION",
    "UVT_REINSCRIPCION": "UVT REINSCIPCION",
    "UVT_EXTRAORDINARIO": "UVT EXTRAORDINARIO",
    "UVT_CONSTANCIA_SIMPLE": "UVT CONSTANCIA SIMPLE",
    "UVT_CONSTANCIA_CALIFICACIONES": "UVT CONSTANCIA_CALIFICACIONES",
    "UVT_TERMINO_ESTUDIOS": "UVT TERMINO ESTUDIOS",
    "UVT_CERTIFICADO_PARCIAL": "UVT CERTIFICADO PARCIAL",
    "UVT_CERTIFICADO_PARCIAL_IMPO": "UVT CERTIFICADO PARCIAL IMPO",
    "UVT_KARDEX": "UVT KARDEX",
    "UVT_RECURSAMIENTO": "UVT RECURSAMIENTO",
    "UVT_EXAM_RECUPERACION": "UVT EXAM RECUPERACION",
    "UVT_REPOS_TITULO": "UVT REPOS_TITULO",
    "UVT_EQUIVALENCIA": "UVT EQUIVALENCIA",
    "UVT_BAJA_DEFINITIVA": "UVT BAJA DEFINITIVA",
    "UVT_MATERIA_EQUIPARADA": "UVT MATERIA EQUIPARADA",
    "UVT_PASE_VEHICULAR": "UVT PASE VEHICULAR",
    "UVT_LIBRETA": "UVT LIBRETA",
    "UVT_CARPETA_3": "UVT CARPETA 3''",
    "UVT_CARPETA_5": "UVT CARPETA 5''",
    "UVT_TITULACIONAL": "UVT TITULACIONAL",
    "UVT_CEDULA": "UVT CEDULA",
    "UVT_MOD_TESIS": "UVT MOD TESIS",
    "UVT_MOD_DIPLOMADO": "UVT MOD DIPLOMADO",
    "UVT_MOD_CURSO_PROFUND": "UVT MOD CURSO PROFUND",
    "UVT_MOD_OTRAS": "UVT_MOD OTRAS",
    "UVT_INGLES": "UVT INGLES",
    "UVT_INGLES_EXTRA": "UVT INGLES EXTRA",
    "UVT_INGLES_COLOCACION": "UVT INGLES_COLOCACION",
    "UVT_ENF_INSCRIPCION": "UVT ENF INSCRIPCION",
    "UVT_ENF_REINSCRIPCION": "UVT_ENF_REINSCRIPCION",
    "UVT_ENF_EXTRAORDINARIO": "UVT ENF EXTRAORDINARIO",
    "UVT_ENF_COLEGIATURA": "UVT ENF COLEGIATURA",
    "UVT_ENF_NIVELACION": "UVT ENF NIVELACION",
    "UVT_ENF_PRACTICAS": "UNVT ENF PRACTICAS",
    "OTRO": "OTRO",
    "UVT_MAESTRIA_COLEGIATURA": " UVT MAESTRIA COLE",
    "UVT_MAESTRIA_INSCRIPCION": "UVT MAESTRIA INSCRIPCION",
    "UVT_MAESTRIA_REINSCRIPCION": "UVT MAESTRIA REINSCRIPCION",
};

export const verifyPayments = status => {
    return (status === "MOROSO" || status === "BAJATEMPORAL" || status === "BAJADEFINITIVA");
};

export const MAJORS_MODES = {
    "AMBIENTAL": ['MIXTA'],
    "INDUSTRIAL": ['MIXTA'],
    "PETROLERA": ['MIXTA'],
    "ADMINISTRACION": ['MIXTA'],
    "LOGISTICA": ['ESCOLARIZADO'],
    "DERECHO": ['MIXTA'],
    "PSICOPEDAGOGIA": ['ESCOLARIZADO'],
    "MAESTRIAPETROLERA": ['ESCOLARIZADO'],
    "MAESTRIAEDUCACION": ['ESCOLARIZADO'],
    "ENFERMERIA": ['ESCOLARIZADO'],
    "ENFERMERIA_SEMESTRAL": ['ESCOLARIZADO'],
};

export function getCycles() {
    let cycles = {};
    for (let year = new Date().getFullYear() + 10; year > 2010; year--) {
        for (let period = 1; period < 4; period++) {
            cycles[`${year - 2000}-0${period}`] = `${year - 2000}-0${period}`;
        }
        cycles[`${year - 2000}-A`] = `${year - 2000}-A`;
        cycles[`${year - 2000}-B`] = `${year - 2000}-B`;
    }
    const availability = {'NO DISPONIBLE': 'NO DISPONIBLE'};
    return {...availability, ...cycles};
}

export const statuses = () => {
    return {
        "ACTIVO": "Activo",
        "INACTIVO": "Inactivo",
        "BAJATEMPORAL": "Baja Temporal",
        "BAJADEFINITIVA": "Baja Definitiva",
        "MOROSO": "Moroso",
        "ACTIVO_MOROSO": "Activo Moroso",
        "TITULADO": "Titulado",
        "EGRESADO": "Egresado",
        "REINGRESO": "Reingreso",
        "SIN_PAGOS": "Sin PagoS",
    }
};

export const randomString = (strLength) => {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for ( let i = 0; i < strLength; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export const formatPhoneNumber = (phone) => {
    let cleaned = ('' + phone).replace(/\D/g, '')
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return '(' + match[1] + ') ' + match[2] + ' ' + match[3]
    }
    return phone;
}

